import './header.scss';

import React from 'react';
import { Link } from 'react-router-dom';

import ounic from '../../assets/brand/ounic.svg';

export const Header = () => {
  const [isSticky, setIsSticky] = React.useState(false);
  const headerRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    const onScrolling = () => {
      const offset = headerRef.current?.offsetHeight ?? 0;
      setIsSticky(window.pageYOffset > offset);
    };

    window.addEventListener('scroll', onScrolling);
    onScrolling();

    return () => window.removeEventListener('scroll', onScrolling);
  }, []);

  return (
    <header
      ref={headerRef}
      className={`header navbar navbar-expand-lg navbar-light${isSticky ? ' navbar-stuck' : ''}`}
      id="header"
    >
      <div className="container px-3">
        <Link to="/" className="navbar-brand pe-3">
          <img src={ounic} alt="Ounic Logo" width={100} />
        </Link>
        <div id="navbarNav" className="offcanvas offcanvas-end">
          <div className="offcanvas-header border-bottom">
            <h5 className="offcanvas-title">Menu</h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/about-us" className="nav-link">
                  About us
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/our-works" className="nav-link">
                  Our works
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/our-products" className="nav-link">
                  Our products
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};
